import * as ko from "knockout";
import PromiseRequest from "../../../req/PromiseRequest";
import {IMessageData, IRecievedMessage} from "../../../index";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {global, lm} from "../../../appContext";
import buttonsHtml from './buttons.html?raw';

export let template = buttonsHtml;

interface IParams {
    obj: IRecievedMessage
    onUpdate: (obj: IRecievedMessage) => void
    onError: (reason: string) => void
}

export class viewModel {
    private isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private isWaiting: KnockoutObservable<boolean | null> = ko.observable(null);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private reqUpdateReceivedMessage: PromiseRequest = global.getPromiseRequest('updatereceivedmessage');
    private obj: IRecievedMessage;
    private isComplete: KnockoutObservable<boolean | null> = ko.observable(null);

    constructor(private params: IParams) {
        this.obj = params.obj;
        this.isComplete(!!this.obj.read && !!this.obj.completed);
        this.isReady(true);
    }

    private attr = ko.pureComputed((): object => {
        const title = this.isComplete()
            ? this.obj.istask ? `mark as incomplete` : `mark as unread`
            : this.obj.istask ? `mark as completed` : `mark as read`
        return {title: lm.t(title)}
    })

    private icon = ko.pureComputed((): string => {
        return this.isComplete() ? 'fa-undo' : 'fa-check';
    })

    private onClick() {
        this.isReady(false);
        this.isWaiting(true);
        Promise.resolve()
            .then(() => {
                this.reqUpdateReceivedMessage.abort();
                return this.reqUpdateReceivedMessage
                    .request({
                        id: this.obj.id,
                        completed: !this.isComplete(),
                        read: !this.isComplete(),
                    })
            })
            .then(() => {
                global.cacheManager.removeCache('getobject');
                global.cacheManager.removeCache('searchobject');
                this.params.onUpdate(this.obj);
                // global.login.checkForUpdates();
            })
            .catch((reason: string) => {
                this.isWaiting(false);
                this.isReady(true);
                this.params.onError?.(reason);
            });
    }

    dispose() {
        this.kosub.unsuscribeAll();
        this.reqUpdateReceivedMessage.abort();
    }
}
